<template>
    <div class="context-menu-container">
        <div>
            <!--Coords-->
            <div class="group">
                <div class="label">{{ $t('location') }}</div>
                <div class="valuelink">
                    <a
                        href="#"
                        @click.stop.prevent="$_centerOnMarker"
                        :title="$t('labelCenterPickedLocation')"
                    >
                        <span>
                            <img
                                style="margin-right: 5px"
                                src="~@/assets/imported-icons/ic_fluent_location_20_regular.svg"
                                :alt="$t('labelCenterPickedLocation')"
                            />
                            {{ getCoord }}
                        </span>
                    </a>
                    <a
                        href="#"
                        @click.stop.prevent="$_copyToClipboard"
                        :title="$t('labelCopyCoordsToClipBoard')"
                    >
                        <span class="ml-1">
                            <img
                                src="~@/assets/imported-icons/ic_fluent_copy_20_regular.svg"
                                :alt="$t('labelCopyCoordsToClipBoard')"
                            />
                        </span>
                    </a>
                </div>
            </div>
            <!--Address-->
            <div class="group">
                <div class="label">{{ $t('address') }}</div>
                <span class="value">{{ this.addressAtPoint.address }}</span>
                <div v-if="addressAtPoint.addressData">
                    <!--Stuf Info-->
                    <a
                        v-if="userIsStufAuthorized"
                        href="#"
                        @click.stop.prevent="$_onShowStuf"
                        v-ng-usage:click="{
                            name: 'externalLink',
                            linkName: 'Stuf'
                        }"
                        :title="`${$t('stuf.bewonersLinkTitle')}`"
                    >
                        {{ $t('stuf.bewoners') }}
                    </a>
                    <span v-if="userIsStufAuthorized && userIsKvkAuthorized">
                        /
                    </span>
                    <!--KvK Info-->
                    <a
                        v-if="userIsKvkAuthorized"
                        href="#"
                        @click.stop.prevent="$_onShowKvk"
                        v-ng-usage:click="{
                            name: 'externalLink',
                            linkName: 'Kvk'
                        }"
                        :title="`${$t('kvk.companiesLinkTitle')}`"
                    >
                        {{ $t('kvk.companies') }}
                    </a>
                </div>
                <div v-if="addressAtPoint.addressData">
                    <!--EnergyLabel Info-->
                    <a
                        v-if="userIsEnergyLabelAuthorized"
                        href="#"
                        @click.stop.prevent="$_onShowEnergyLabel"
                        v-ng-usage:click="{
                            name: 'externalLink',
                            linkName: 'EnergyLabel'
                        }"
                        :title="$t('energyLabel.labelEnergylabel')"
                    >
                        {{ $t('energyLabel.labelEnergylabel') }}
                    </a>
                    <!--Woz Info-->
                    <span
                        v-if="
                            userIsEnergyLabelAuthorized && userIsWozAuthorized
                        "
                    >
                        /
                    </span>
                    <template v-if="userIsWozAuthorized">
                        <a
                            v-if="!isWozDisabled"
                            href="#"
                            @click.stop.prevent="$_onShowWozData"
                            v-ng-usage:click="{
                                name: 'externalLink',
                                linkName: 'WOZ'
                            }"
                            :title="$t('woz.linkTitle')"
                        >
                            {{ $t('apiSettings.woz') }}
                        </a>
                        <span v-else :title="wozErrorLinkTitle">
                            {{ $t('apiSettings.woz') }}
                        </span>
                    </template>
                </div>
            </div>
            <!--Perceel-->
            <div class="group" v-if="addressAtPoint.parcelTitle">
                <div class="label">Perceel</div>
                <!--BRK Info-->
                <a
                    v-if="userIsBrkAuthorized"
                    href="#"
                    @click.stop.prevent="$_onShowBrk"
                    v-ng-usage:click="{
                        name: 'externalLink',
                        linkName: 'Brk'
                    }"
                    :title="`${$t('stuf.toon')} ${$t(
                        'cadastralInformationTitle'
                    ).toLowerCase()}`"
                >
                    <span class="valuelink">
                        {{ addressAtPoint.parcelTitle }}
                    </span>
                </a>
                <span v-else class="valuelink">{{
                    addressAtPoint.parcelTitle
                }}</span>
            </div>
        </div>
        <div>
            <!--Image connections-->
            <div class="label">{{ $t('viewImages') }}:</div>
            <div
                class="group"
                v-if="connectionsImage && connectionsImage.length > 0"
            >
                <!--Images horizontal-->
                <div
                    class="h4 mb-0 connections"
                    v-for="conn in connectionsImage"
                    v-bind:key="conn.id"
                    href="#"
                    @click.prevent="$_clickLink(conn)"
                    v-ng-usage:click="{
                        name: 'externalLink',
                        linkName: conn.urlConnectionLicense.name
                    }"
                >
                    <span
                        class="url-icon"
                        :title="conn.urlConnectionLicense.name"
                    >
                        <img
                            :src="conn.imageData"
                            alt="afbeelding"
                            class="image"
                        />
                    </span>
                </div>
                <!--Only one image-->
                <div
                    v-if="connectionsImage && connectionsImage.length === 1"
                    class="value valueUrl"
                >
                    <a
                        href="#"
                        @click.prevent="$_clickLink(connectionsImage[0])"
                        v-ng-usage:click="{
                            name: 'externalLink',
                            linkName:
                                connectionsImage[0].urlConnectionLicense.name
                        }"
                        >{{ $t('viewImages') }}
                        {{ connectionsImage[0].urlConnectionLicense.name }}</a
                    >
                </div>
            </div>
            <!--Other connections-->
            <div
                class="group"
                v-if="connectionsOther && connectionsOther.length > 0"
            >
                <div v-for="conn in connectionsOther" v-bind:key="conn.id">
                    <a :href="conn.urlFormatted" target="_blank">
                        {{ $_getlinkText(conn) }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { doubleToString, stringNotEmpty } from '../../../../services/utilities';
    import {
        URL_CONNECTION_TYPE,
        KADASTRALEGEMEENTECODES
    } from '../../../../constants';
    import { mapState, mapActions, mapGetters } from 'vuex';
    import Feature from 'ol/Feature';
    import Point from 'ol/geom/Point';

    export default {
        name: 'context-menu',

        props: { contextObject: { type: Object, required: false } },

        data() {
            return {
                connections: null,
                coordX: null,
                coordY: null,
                wozApiId: null
            };
        },

        computed: {
            ...mapState([
                'userIsBrkAuthorized',
                'userIsStufAuthorized',
                'userIsKvkAuthorized',
                'userIsWozAuthorized',
                'userIsEnergyLabelAuthorized',
                'addressAtPoint'
            ]),
            ...mapGetters([
                'isMobile',
                'getUserData',
                'getUserInfo',
                'getUserWozApis'
            ]),

            getCoord() {
                return (
                    this.coordX && this.coordY && `${this.coordX} ${this.coordY}`
                );
            },

            wozErrorLinkTitle() {
                const gemeente = KADASTRALEGEMEENTECODES.find(
                    ({ Code }) =>
                        this.addressAtPoint.kadastraleGemeenteCode ===
                        Code.toString()
                );
                return this.$t('woz.errorLinkTitle', [
                    `(${gemeente.Toelichting} - ${gemeente.Waarde})`
                ]);
            },

            isWozDisabled() {
                return !this.wozApiId;
            },

            connectionsImage() {
                return this.connections?.filter(
                    (c) =>
                        c.urlConnectionLicense.type ===
                        URL_CONNECTION_TYPE.StreetView
                );
            },

            connectionsOther() {
                return this.connections?.filter(
                    (c) =>
                        c.urlConnectionLicense.type === URL_CONNECTION_TYPE.Others
                );
            },

            userInfo() {
                return this.isMobile ? this.getUserData : this.getUserInfo;
            }
        },

        mounted() {
            this.$_loadConnectionLicenses();
            this.$_showContextMenu();
            this.$_getWozApiId();
        },

        methods: {
            ...mapActions([
                'setParcelContour',
                'getUrlConnections',
                'clearTabsRight',
                'setTabToFocus'
            ]),
            // Retrieve available licences
            async $_loadConnectionLicenses() {
                this.connections = await this.getUrlConnections();

                // Moved changing URLs to here so we are sure the connections are loaded
                //
                // Replace value in url for:
                // [URL]
                // [RD_X] / [RD_Y]
                // [RD_MIN_X] / [RD_MIN_Y] / [RD_MAX_X] / [RD_MAX_Y]
                // [USER]
                const extent = 100;
                const coordX = this.contextObject.point[0];
                const coordY = this.contextObject.point[1];

                this.connections?.forEach((conn) => {
                    // Replace questions marks with ampersands if neccesary
                    const url =
                        conn.url.includes('?') &&
                        conn.urlConnectionLicense.url.includes('[URL]')
                            ? conn.urlConnectionLicense.url.replaceAll('?', '&')
                            : conn.urlConnectionLicense.url;
                    // Generate the formatted url
                    conn.urlFormatted = url
                        .replace('[URL]', conn.url)
                        .replace('[RD_X]', coordX)
                        .replace('[RD_Y]', coordY)
                        .replace('[RD_MIN_X]', coordX - extent)
                        .replace('[RD_MIN_Y]', coordY - extent)
                        .replace('[RD_MAX_X]', coordX + extent)
                        .replace('[RD_MAX_Y]', coordY + extent)
                        .replace('[USER]', this.userInfo.userName);

                    // Additionally replace token if there is one
                    if (conn.token) {
                        conn.urlFormatted = conn.urlFormatted.replace(
                            '[TOKEN]',
                            conn.token
                        );
                    }
                });
            },

            $_getWozApiId() {
                // If there is exactly 1 Woz Api then use that 1
                if (this.getUserWozApis.length === 1) {
                    this.wozApiId = this.getUserWozApis[0].id;
                    return;
                }

                // When more than 1 WOZ api and kadastraleGemeenteCode has changed
                if (
                    this.$store.getters.getUserWozApiData.kadGemCode !==
                    this.addressAtPoint.kadastraleGemeenteCode
                ) {
                    // Get the Id from the Woz api
                    this.$_getWozApiIdAtAddress();
                } else {
                    this.wozApiId = this.$store.getters.getUserWozApiData.apiId;
                }
            },

            $_getlinkText(connection) {
                if (connection && stringNotEmpty(connection.linkText)) {
                    return connection.linkText;
                } else {
                    return connection.urlConnectionLicense.name;
                }
            },

            async $_showContextMenu() {
                this.coordX = doubleToString(this.contextObject.point[0]);
                this.coordY = doubleToString(this.contextObject.point[1]);

                // Check if there is a parcelGeometry and when there is, if it has coordinates
                if (
                    this.addressAtPoint.parcelGeometry &&
                    this.addressAtPoint.parcelGeometry.coordinates.length > 0
                ) {
                    // Dispatch coordinates
                    this.setParcelContour(
                        this.addressAtPoint.parcelGeometry.coordinates
                    );
                }
            },

            $_clickLink(connection) {
                if (connection.secured) {
                    this.$_openSecuredUrl(
                        connection,
                        this.contextObject.point[0],
                        this.contextObject.point[1],
                        '28992'
                    );
                } else {
                    this.$_openWindow(
                        connection.urlFormatted,
                        connection.urlConnectionLicense.name
                    );
                }
            },

            async $_getWozApiIdAtAddress() {
                // Get the WOZ API for the current kadastraleGemeenteCode
                try {
                    const apiResult = await this.$store.dispatch('useApiData', {
                        name: 'GetWozApiByKadastraleGemeenteCode',
                        parameters: {
                            kadastraleGemeenteCode:
                                this.addressAtPoint.kadastraleGemeenteCode
                        }
                    });

                    this.wozApiId = apiResult?.data?.id;

                    // Save the last known kadastraleGemeenteCode
                    this.$store.commit('SET_USER_WOZ_API_DATA', {
                        kadGemCode: this.addressAtPoint.kadastraleGemeenteCode,
                        apiId: this.wozApiId
                    });
                } catch (error) {
                    this.$store.commit('ADD_STATUS_MESSAGE', {
                        message: this.$t('apiSettings.errorGetApiTypeSettings', [
                            error.message
                        ]),
                        variant: 'info',
                        autoHideDelay: 5000
                    });
                }
            },

            $_centerOnMarker() {
                const point = this.$store.state.pointer?.location?.point;
                const feature = new Feature({ geometry: new Point(point) });
                this.$store.dispatch('zoomToFeature', {
                    mapName: 'main',
                    feature: [feature]
                });
            },

            $_copyToClipboard() {
                let coords = this.getCoord;
                navigator.clipboard.writeText(coords);
            },

            $_onShowBrk() {
                this.$emit('openBrkDetails', {
                    parcelIdentificationLocalID:
                        this.addressAtPoint.parcelIdentificationLocalID,
                    title: this.addressAtPoint.parcelTitle
                });
            },

            $_onShowStuf() {
                let searchdata = { ...this.addressAtPoint.addressData };
                delete searchdata.city;
                delete searchdata.streetName;
                // We delete all data to the right of this tab.
                // We give tabToFocus a value so tabs.vue knows to set focus to the last tab.
                this.clearTabsRight({ title: this.$t('pickedLocation') });
                this.setTabToFocus({ title: this.$t('pickedLocation') });
                this.$emit('openStufDetails', {
                    addressdata: searchdata,
                    title: `${this.addressAtPoint.addressData.displayName}`
                });
            },

            $_onShowKvk() {
                let searchdata = { ...this.addressAtPoint.addressData };
                delete searchdata.city;
                delete searchdata.streetName;
                // We delete all data to the right of this tab.
                // We give tabToFocus a value so tabs.vue knows to set focus to the last tab.
                this.clearTabsRight({ title: this.$t('pickedLocation') });
                this.setTabToFocus({ title: this.$t('pickedLocation') });
                this.$emit('openKvkDetails', {
                    addressdata: searchdata,
                    title: `${this.addressAtPoint.addressData.displayName}`
                });
            },

            async $_onShowEnergyLabel() {
                this.$emit('openEnergyLabel', {
                    addressdata: this.addressAtPoint.addressData,
                    title: `${this.addressAtPoint.addressData.displayName}`
                });
            },

            $_onShowWozData() {
                this.$emit('openWozData', {
                    addressdata: this.addressAtPoint.addressData,
                    wozApiId: this.wozApiId,
                    title: this.$t('woz.objects')
                });
            },

            $_getKavel10PanoSearchParam(linkText) {
                const hasKavel10 = linkText
                    .toLowerCase()
                    .includes('kavel10'.toLowerCase());
                const hasPanorama = linkText
                    .toLowerCase()
                    .includes('panorama'.toLowerCase());
                return hasKavel10 && hasPanorama ? '&mode=pano' : '';
            },

            async $_openSecuredUrl(connection, x, y, srid) {
                await this.$store
                    .dispatch('useApiData', {
                        name: 'GetSecuredUrl',
                        parameters: {
                            OrganizationUrlConnectionId: connection.id,
                            x: x,
                            y: y,
                            srid: srid
                        }
                    })
                    .then(
                        (result) => {
                            if (result?.data) {
                                const securedUrl = encodeURIComponent(result.data);
                                const linkText = encodeURIComponent(
                                    this.$_getlinkText(connection)
                                );
                                const routeData = this.$router.resolve(
                                    `/securedUrl/${connection.id}/${linkText}/${securedUrl}`
                                );
                                this.$_openWindow(
                                    `${
                                        routeData.href
                                    }${this.$_getKavel10PanoSearchParam(linkText)}`,
                                    connection.urlConnectionLicense.name
                                );
                            } else {
                                this.$store.commit('ADD_STATUS_MESSAGE', {
                                    message: this.$t('errorUrlConnectionOpen'),
                                    variant: 'danger',
                                    autoHideDelay: 10000
                                });
                            }
                        },
                        (error) => {
                            this.$store.commit('ADD_STATUS_MESSAGE', {
                                message: `${this.$t(
                                    'errorUrlConnectionOpen'
                                )} ${this.$t('error')}: ${this.$t(error.message)}`,
                                variant: 'danger',
                                autoHideDelay: 10000
                            });
                        }
                    );
            },

            $_openWindow(src, windowName) {
                window.open(src, `NG_${windowName}`);
            }
        },

        watch: {
            contextObject(newValue, oldValue) {
                if (
                    newValue !== null &&
                    newValue !== undefined &&
                    JSON.stringify(newValue) !== JSON.stringify(oldValue)
                ) {
                    this.$_showContextMenu();
                }
            }
        }
    };
</script>

<style>
.context-menu-container .btn.dropdown-toggle.btn-link {
    background-color: initial;
    border: none;
    box-shadow: none;
    padding: 0;
}

.context-menu-container .dropdown-item {
    padding-left: 10px;
    padding-right: 10px;
    text-decoration: none;
}

.context-menu-container .dropdown-menu {
    transform: translate3d(0px, 25px, 0px) !important;
}
</style>

<style scoped>
.context-menu-container {
    display: flex;
    flex-wrap: nowrap;
    padding: 5px;
    position: absolute;
    width: 100%;
    height: 100%;
    overflow-y: auto;
}

.context-menu-container > div:nth-child(1) {
    min-width: 250px;
    max-width: 500px;
}

.context-menu-container > div:nth-child(2) {
    padding-top: 22px;
}

.context-menu-container .group {
    margin-bottom: 1rem;
}

.context-menu-container .label {
    margin-bottom: 0.25rem;
}

.context-menu-container .value {
    font-weight: bold;
    padding-right: 50px;
    white-space: pre-line;
    display: inline-flex;
    align-items: center;
}

.context-menu-container .valuelink {
    white-space: pre-line;
    display: inline-flex;
    align-items: center;
}

.context-menu-container .valueUrl {
    font-weight: normal;
}

.context-menu-container .image {
    margin-left: 5px;
    margin-right: 5px;
    width: 20px;
    height: 20px;
}

.connections {
    display: inline-flex;
}
</style>

<style scoped lang="scss">
.url-icon {
    padding: 3px;
    &:hover {
        background-color: #ebeaea;
    }
}
</style>
